import {toast} from 'react-toastify';
import {Auth} from 'aws-amplify';
import {observable, runInAction} from 'mobx';

/* Number of API requests in flight, used for the global progress bar */
export const apiActivity = observable({pending: 0});

export class ApiError extends Error
{
}

/* The API answers errors with {error: true, message: ...}; message may be a string or {error: {code, message}}. */
function errorMessage(json, response)
{
    const message = json && json.message;
    if (message && message.error && message.error.message)
    {
        return message.error.message;
    }
    if (message && message.message)
    {
        return message.message;
    }
    if (typeof message === "string" && message)
    {
        return message;
    }
    return "Anfrage fehlgeschlagen (HTTP " + response.status + ").";
}

/**
 * Parses an API response. Rejects with an ApiError on HTTP errors or {error: true} payloads,
 * so success handlers only run when the request really succeeded.
 */
export function parseResponse(response)
{
    return response.json()
        .catch(() => null)
        .then((json) =>
        {
            if (!response.ok || !json || json.error)
            {
                throw new ApiError(errorMessage(json, response));
            }
            return json;
        });
}

/* Shows an error once as a toast and logs it to the console. */
export function notifyError(error)
{
    console.error(error);

    if (error && error.notified)
    {
        return;
    }
    if (error && typeof error === "object")
    {
        error.notified = true;
    }

    const message = error instanceof ApiError ? error.message : "Fehler: " + ((error && error.message) || String(error));
    toast.error(message);
}

/**
 * Calls the API with the current Cognito access token and resolves with the parsed response.
 * Rejects with an ApiError if the request or the API reports an error.
 */
export function apiFetch(url, options = {})
{
    runInAction(() => apiActivity.pending++);

    return Auth.currentSession()
        .then((session) => fetch(url, {
            ...options,
            headers: {
                ...(options.headers || {}),
                Authorization: "Bearer " + session.getAccessToken().getJwtToken()
            }
        }))
        .then(parseResponse)
        .finally(() => runInAction(() => apiActivity.pending--));
}
